import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Fragment, forwardRef, memo, useMemo, } from 'react';
import { ButtonIcon, } from './ButtonIcon';
import { ButtonText } from './ButtonText';
import { colors, iconAlignments, sizes, types, } from './constants';
import { LoadingSpinner } from './LoadingSpinner';
import useButtonStyles from './useButtonStyles';
const defaultProps = {
    iconAlignment: iconAlignments.left,
    onBlur: () => { },
    onClick: () => { },
    onFocus: () => { },
    onKeyDown: () => { },
    onKeyUp: () => { },
    onMouseDown: () => { },
    onMouseLeave: () => { },
    onMouseUp: () => { },
    onTouchEnd: () => { },
    onTouchMove: () => { },
    onTouchStart: () => { },
    size: sizes.medium,
    type: types.primary,
};
const BaseButton = forwardRef(({ ariaDescribedBy, ariaLabel, ariaLabelledBy, ariaPressed, className, color, customIcon, disabled, download, expand, expandAt, href, iconAlignment = defaultProps.iconAlignment, iconType, loading, onBlur = defaultProps.onBlur, onClick = defaultProps.onClick, onFocus = defaultProps.onFocus, onKeyDown = defaultProps.onKeyDown, onKeyUp = defaultProps.onKeyUp, onMouseDown = defaultProps.onMouseDown, onMouseLeave = defaultProps.onMouseLeave, onMouseUp = defaultProps.onMouseUp, onTouchEnd = defaultProps.onTouchEnd, onTouchMove = defaultProps.onTouchMove, onTouchStart = defaultProps.onTouchStart, rel, size = defaultProps.size, submit, target, text, type = defaultProps.type, }, ref) => {
    const buttonStyles = useButtonStyles({
        expand,
        expandAt,
        iconAlignment,
        size,
        type: color === colors.facebook ? colors.facebook : type,
    });
    const buttonContent = useMemo(() => (_jsxs(Fragment, { children: [_jsx(ButtonIcon, { customIcon: customIcon, hasText: Boolean(text), iconAlignment: iconAlignment, iconType: iconType, loading: loading, size: size }), text && (_jsx(ButtonText, { loading: loading, text: text })), _jsx(LoadingSpinner, { loading: loading, size: size, type: type })] })), [
        customIcon,
        iconAlignment,
        iconType,
        loading,
        size,
        text,
        type,
    ]);
    if (href && !disabled) {
        return (_jsx("a", Object.assign({ "aria-describedby": ariaDescribedBy, "aria-label": ariaLabel, "aria-labelledby": ariaLabelledBy, className: className, css: buttonStyles, download: download, href: href, ref: ref, rel: rel, target: target }, { children: buttonContent })));
    }
    return (_jsx("button", Object.assign({ "aria-describedby": ariaDescribedBy, "aria-label": ariaLabel, "aria-labelledby": ariaLabelledBy, "aria-pressed": ariaPressed, className: className, css: buttonStyles, disabled: disabled, onBlur: onBlur, onClick: loading ? undefined : onClick, onFocus: onFocus, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onMouseDown: onMouseDown, onMouseLeave: onMouseLeave, onMouseUp: onMouseUp, onTouchEnd: onTouchEnd, onTouchMove: onTouchMove, onTouchStart: onTouchStart, ref: ref, type: submit ? 'submit' : 'button' }, { children: buttonContent })));
});
BaseButton.displayName = 'BaseButton';
const MemoizedBaseButton = memo(BaseButton);
export { MemoizedBaseButton as BaseButton };
